import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IChatInput } from '../../interfaces/AppInterfaces';

const initialState: any = {
    ticketStatusChangedOn: '',
    ticketId: ''
};

const ticketStatusSlice = createSlice({
    name: 'ticketStatus',
    initialState,
    reducers: {
        setTicketStatusChanged: (state, action: PayloadAction<{ ticketStatusChangedOn: string, ticketId: string }>) => {
            state.ticketStatusChangedOn = action.payload.ticketStatusChangedOn;
            state.ticketId = action.payload.ticketId;
        },
    },
});

export const { setTicketStatusChanged } = ticketStatusSlice.actions;
export default ticketStatusSlice.reducer;